import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const NotebookCoverJumboRolls = () => (
  <ProductDetailPage {...getProductPageConfig('notebookCoverJumboRolls')} />
);

export default NotebookCoverJumboRolls;
